import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Stack, TextField } from '@mui/material';
import React from 'react';

const ObjectEditDialog = ({ open, setOpen, metadata, update }) => {
  const [option, setOption] = React.useState({});
  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    update(option);
  };

  React.useEffect(() => {
    setOption({ ...option, key: metadata?.id, value: metadata?.attributes?.label });
  }, [metadata]);
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Edit Object</DialogTitle>
      <DialogContent>
        <DialogContentText>Option(s) are key:value pair, example: birth_date:Birth Day</DialogContentText>
        <TextField
          onChange={(e) => setOption({ ...option, key: e.currentTarget.value.replace(/\s+/g, '').toLowerCase() })}
          required
          margin='dense'
          id='key'
          label='Key'
          type='text'
          fullWidth
          variant='standard'
          value={option?.key}
        />
        <TextField
          onChange={(e) => setOption({ ...option, value: e.currentTarget.value })}
          required
          autoFocus
          margin='dense'
          id='label'
          label='Label'
          type='text'
          fullWidth
          variant='standard'
          value={option.value}
        />
        <Stack direction='row' justifyContent='flex-end' m={2}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ObjectEditDialog;
